import { render, staticRenderFns } from "./scope60.vue?vue&type=template&id=98f01eda&scoped=true"
import script from "./scope60.vue?vue&type=script&lang=js"
export * from "./scope60.vue?vue&type=script&lang=js"
import style0 from "./scope60.vue?vue&type=style&index=0&id=98f01eda&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f01eda",
  null
  
)

export default component.exports